import { useContext, useMemo, useState } from "react";
import { ChevronDown } from "lucide-react";
import { ThemeContext } from "src/context/ThemeContext";
import {
  AccountType,
  ManageAccountContext,
} from "src/context/ManageAccountContext";

const accountLabel: Record<AccountType, string> = {
  marketplace: "Marketplace account",
  manage: "Manage account",
};

export default function SwitchAccount() {
  const { theme } = useContext(ThemeContext);
  const { activeAccount, switchAccount } = useContext(ManageAccountContext);
  const [open, setOpen] = useState(false);

  const options = useMemo(
    () => (["marketplace", "manage"] as AccountType[]).filter((a) => a !== activeAccount),
    [activeAccount]
  );

  return (
    <div className="relative w-fit">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`
          inline-flex items-center gap-2 rounded-md border px-3 py-2 text-sm font-medium
          ${theme === "dark" ? "border-white/10 bg-[#2b2b2b] text-white" : "border-black/10 bg-white text-primary"}
        `}
      >
        <span className="truncate">{accountLabel[activeAccount]}</span>
        <ChevronDown className="h-4 w-4" />
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setOpen(false)}
          />
          <div
            className={`
              absolute left-0 top-[calc(100%+8px)] z-20 min-w-[220px] overflow-hidden rounded-xl border shadow-lg
              ${theme === "dark" ? "border-white/10 bg-[#2b2b2b]" : "border-black/10 bg-white"}
            `}
          >
            {options.map((opt) => (
              <button
                key={opt}
                type="button"
                onClick={() => {
                  setOpen(false);
                  switchAccount(opt);
                }}
                className={`
                  flex w-full items-center justify-between px-3 py-2 text-left text-sm
                  ${theme === "dark" ? "text-white hover:bg-white/5" : "text-primary hover:bg-black/5"}
                `}
              >
                {accountLabel[opt]}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

